import { render, staticRenderFns } from "./TabAttachments.vue?vue&type=template&id=c97a8136"
import script from "./TabAttachments.vue?vue&type=script&lang=ts"
export * from "./TabAttachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports